/**
 * Classe para formatar o field do tipo miles or meters.
 * @author: Adalto Junior
 * DATE: 20/08/2014
 */

Monet.Format = Monet.Format || {};
Monet.Format.MILES_OR_METERS = (function () {

    function MILES_OR_METERS(value) {

        Monet.Format.DISTANCE.apply(this, arguments);

        this.value = value;

        this.toGrid = function () {

          if (typeof this.value === 'number') {
            if (Monet.Session.User.unitSystem === 'NON_METRIC') {
              this.convertMetersToMiles();
              this.format();
              this.value += ' ' + Monet.I18n.getResourcesByKey('UnitSystems.Miles.abbreviation');
            } else {
              this.format();
              this.value += ' ' + Monet.I18n.getResourcesByKey('UnitSystems.Meters.abbreviation');
            }
          } else {
            this.value = '';
          }

          return this;

        };

    }

    return MILES_OR_METERS;

}());
